define('productAlternativeView',[
  'module',
  'marionette',
  'app',
  'jquery',
  'underscore',
  'settings',
  'template!productAlternativeTpl'
], function (
  module,
  Marionette,
  App,
  $,
  _,
  Settings,
  viewTpl
) {
  'use strict';

  module.exports = Marionette.LayoutView.extend({
    template: viewTpl,
    className: 'col-xs-12',

    modelEvents: {
      'change': 'render'
    },

    regions: {},

    ui: {},

    events: {
      'click .btn-remove-alternative': 'onBtnRemoveAlternativeClick'
    },

    onRender: function () {
      if (!this.model.get('direct')) {
        this.$el.css({
          'opacity': '0.7',
          'border-left': '3px solid #ccc',
          'padding-left': '5px'
        });
      }
    },

    serializeData: function () {
      var templateData = this.model.toJSON();
      templateData.imageUrl = templateData.catalogPictureUid ? Settings.url('file', templateData.catalogPictureUid, {
                action: 'res', params: 't'
              })
        : (templateData.catalogPictureUrl || null);
      return templateData;
    },

    onBtnRemoveAlternativeClick: function () {
      var altId = this.model.id || this.model.get('id');
      var productSecId = this.model.get('productSecId') ||
        (this.model.collection && this.model.collection.productSecId);
      if (!altId || !productSecId) return;

      var url = Settings.url('compuzz2', 'v2/pim/products/resellerProduct/' + productSecId + '/alternatives/' + altId);
      var collection = this.model.collection;
      var model = this.model;

      $.ajax({
        type: 'DELETE',
        url: url,
        success: function () {
          if (collection) {
            collection.remove(model);
          }
        }
      });
    }
  });
});

